import React from 'react';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
import { Box } from '@mui/material';

const Page = forwardRef(({ children, title = '', ...other }: any, ref) => (
	<Box ref={ref} {...other}>
		<Helmet>
			<title>{title}</title>
		</Helmet>
		<Box>{children}</Box>
	</Box>
));

Page.displayName = 'Page';

export default Page;
